import { render, staticRenderFns } from "./pluginDialog.vue?vue&type=template&id=27ce4839&"
import script from "./pluginDialog.vue?vue&type=script&lang=ts&"
export * from "./pluginDialog.vue?vue&type=script&lang=ts&"
import style0 from "./pluginDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports